import { hasNativeMessageHandler } from '../runtime/native-bridge.js'

export type RuntimeKind = 'browser' | 'installed-pwa' | 'native-wrapper'
export type StorageTrust = 'ephemeral' | 'trusted-device'

export type SecurityContext = {
    runtimeKind: RuntimeKind
    storageTrust: StorageTrust
}

export type SecurityContextSignals = {
    nativeWrapper: boolean
    secureContext: boolean
    standaloneDisplay: boolean
}

export class SecurityContextService {
    public readonly current: SecurityContext

    public constructor(context: SecurityContext = detectSecurityContext()) {
        this.current = context
    }
}

export function detectSecurityContext(): SecurityContext {
    return createSecurityContextFromSignals({
        nativeWrapper: isNativeWrapper(),
        secureContext: typeof window !== 'undefined' && window.isSecureContext,
        standaloneDisplay: isStandaloneDisplay()
    })
}

export function createSecurityContextFromSignals(signals: SecurityContextSignals): SecurityContext {
    return {
        runtimeKind: getRuntimeKind(signals),
        storageTrust: signals.nativeWrapper ? 'trusted-device' : 'ephemeral'
    }
}

function getRuntimeKind(signals: SecurityContextSignals): RuntimeKind {
    if (signals.nativeWrapper) {
        return 'native-wrapper'
    }

    if (signals.standaloneDisplay) {
        return 'installed-pwa'
    }

    return 'browser'
}

function isNativeWrapper(): boolean {
    if (typeof navigator !== 'undefined' && navigator.userAgent.includes('PWAShell')) {
        return true
    }

    return hasNativeMessageHandler('debug-log')
}

function isStandaloneDisplay(): boolean {
    if (typeof window === 'undefined') {
        return false
    }

    return window.matchMedia('(display-mode: standalone)').matches
}
